class ProductTabs {
  constructor(container) {
    this.container = container;
    this.tabButtons = container.querySelectorAll('.product-tabs__nav-button');
    this.tabPanels = container.querySelectorAll('.product-tabs__panel');
    this.tabItems = container.querySelectorAll('.product-tabs__item');
    this.accordions = container.querySelectorAll('.product-tabs__accordion');
    this.isMobile = window.innerWidth < 750;
    this.init();
  }

  init() {
    if (this.tabButtons.length === 0 || this.tabPanels.length === 0) return;

    // Desktop tab navigation
    this.tabButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        if (!this.isMobile) {
          const targetTab = button.getAttribute('data-tab');
          this.switchTab(targetTab);
        }
      });
    });

    // Handle keyboard navigation for desktop
    this.tabButtons.forEach((button) => {
      button.addEventListener('keydown', (e) => {
        if (!this.isMobile) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const targetTab = button.getAttribute('data-tab');
            this.switchTab(targetTab);
          } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            this.focusNextTab(button);
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            this.focusPreviousTab(button);
          }
        }
      });
    });

    // Handle window resize
    window.addEventListener('resize', () => {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 750;
      
      // Reset state when switching between mobile and desktop
      if (wasMobile !== this.isMobile) {
        this.resetState();
      }
    });

    // Initialize state
    this.resetState();
  }

  resetState() {
    if (this.isMobile) {
      // Mobile: Show all items, first accordion open
      this.tabItems.forEach((item) => {
        item.style.display = 'block';
      });
      
      // Close all accordions except the first one
      this.accordions.forEach((accordion, index) => {
        if (index === 0) {
          accordion.setAttribute('open', '');
        } else {
          accordion.removeAttribute('open');
        }
      });
    } else {
      // Desktop: Show only active tab
      const activeButton = this.container.querySelector('.product-tabs__nav-button.active');
      if (activeButton) {
        const targetTab = activeButton.getAttribute('data-tab');
        this.switchTab(targetTab);
      }
    }
  }

  switchTab(targetTab) {
    // Update buttons
    this.tabButtons.forEach((button) => {
      const isActive = button.getAttribute('data-tab') === targetTab;
      button.classList.toggle('active', isActive);
      button.setAttribute('aria-selected', isActive);
      button.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    // Update panels
    this.tabPanels.forEach((panel) => {
      const isActive = panel.id.includes(targetTab);
      panel.classList.toggle('active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    // Update tab items visibility on desktop
    if (!this.isMobile) {
      this.tabItems.forEach((item) => {
        const itemTab = item.getAttribute('data-tab');
        if (itemTab === targetTab) {
          item.classList.add('active');
          item.style.display = 'block';
          
          const details = item.querySelector('details.product-tabs__accordion');
          if (details) {
            details.setAttribute('open', '');
          }
        } else {
          item.classList.remove('active');
          item.style.display = 'none';
        }
      });
    }

    // Focus the active button (preventScroll so page doesn't jump on load or when switching)
    const activeButton = this.container.querySelector(`[data-tab="${targetTab}"]`);
    if (activeButton && !this.isMobile) {
      activeButton.focus({ preventScroll: true });
    }
  }

  focusNextTab(currentButton) {
    const buttons = Array.from(this.tabButtons);
    const currentIndex = buttons.indexOf(currentButton);
    const nextIndex = (currentIndex + 1) % buttons.length;
    buttons[nextIndex].focus();
  }

  focusPreviousTab(currentButton) {
    const buttons = Array.from(this.tabButtons);
    const currentIndex = buttons.indexOf(currentButton);
    const previousIndex = (currentIndex - 1 + buttons.length) % buttons.length;
    buttons[previousIndex].focus();
  }
}

// Initialize tabs on page load
if (!window.productTabsInitialized) {
  window.productTabsInitialized = true;
  
  function initProductTabs() {
    const tabContainers = document.querySelectorAll('.product-tabs, product-tabs');
    tabContainers.forEach((container) => {
      if (!container.productTabsInstance) {
        container.productTabsInstance = new ProductTabs(container);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTabs);
  } else {
    initProductTabs();
  }
}
